import { Box, CircularProgress, Grid } from "@mui/material"
import React, { useContext, useMemo } from "react"
import { useNavigate } from "react-router-dom"
import { CustomBottomNavigation } from "../../../../../components/buttons/navigate-button/CustomBottomNavigation"
import { pagesUrl } from "../../../../../core/appConstants"
import { RseeDocumentListContext } from "../../../../../core/context/beem-pilot/rsee/RseeDocumentListContext"
import { ProjectContext } from "../../../../../core/context/project/ProjectContext"
import { ProjectStatusEnum } from "../../../../../core/enum/projectStatusEnum"
import { resolveUrl } from "../../../../../core/services/http-service"
import { RseeDocumentList } from "./components/RseeDocumentList"
import { RseeDocumentListEmpty } from "./components/RseeDocumentListEmpty"

export function BeemPilotTab(): React.JSX.Element {
  const navigate = useNavigate()

  const { project } = useContext(ProjectContext)
  const { rseeDocumentList, isLoading } = useContext(RseeDocumentListContext)

  const isRseeDocumentListExisting = useMemo(() => rseeDocumentList.length > 0, [rseeDocumentList.length])

  if (!project || isLoading) {
    return (
      <Box height="60vh" width="100%" display="flex" justifyContent="center" alignItems="center">
        <CircularProgress />
      </Box>
    )
  } else {
    return (
      <Grid container spacing={2}>
        {isRseeDocumentListExisting ? (
          <>
            <Grid item xs={12}>
              <RseeDocumentList project={project} />
            </Grid>

            {project?.status === ProjectStatusEnum.IN_PROGRESS && (
              <CustomBottomNavigation
                actionLabel="Ajouter un fichier RSEE"
                validateAction={() => navigate(resolveUrl(pagesUrl.BEEM_PILOT_UPLOAD_PAGE, [project?.id, "new"]))}
              />
            )}
          </>
        ) : (
          <Grid item xs={12}>
            <RseeDocumentListEmpty />
          </Grid>
        )}
      </Grid>
    )
  }
}
